<button
  #triggerBtn
  type="button"
  class="tt-filter-icon-btn"
  [class.tt-filter-icon-btn--active]="panelOpen"
  [disabled]="disabled"
  [attr.aria-label]="panelAriaLabel"
  [attr.title]="triggerTitle"
  [attr.aria-expanded]="panelOpen"
  [attr.aria-haspopup]="'dialog'"
  (click)="togglePanel()"
>
  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10m-11 9h12a2 2 0 002-2V7a2 2 0 00-2-2H6a2 2 0 00-2 2v11a2 2 0 002 2z"></path>
  </svg>
</button>

<div
  #panelEl
  *ngIf="panelOpen"
  class="tt-filter-overlay-panel tt-chart-range-controls__panel fixed"
  [ngStyle]="panelStyle"
  role="dialog"
  [attr.aria-label]="panelAriaLabel"
  (mousedown)="onPanelPointerDown($event)"
>
  <div class="flex flex-col gap-3 tt-chart-range-controls">
    <div class="flex flex-wrap items-center gap-2" role="tablist" [attr.aria-label]="granularityAriaLabel">
      <span class="text-sm text-neutral-600 dark:text-neutral-400 mr-1">Rozlišení:</span>
      <button
        *ngFor="let opt of granularityOptions; trackBy: trackOption"
        type="button"
        role="tab"
        [attr.aria-selected]="granularity === opt.id"
        [title]="opt.hint || null"
        (click)="selectGranularity(opt.id)"
        [disabled]="disabled"
        class="tt-chart-range-controls__granularity-btn"
        [class.tt-chart-range-controls__granularity-btn--active]="granularity === opt.id"
      >
        {{ opt.label }}
      </button>
    </div>

    <div class="flex flex-col gap-3">
      <div>
        <label class="tt-chart-range-controls__label block mb-1" [for]="idPrefix + '-start'">{{ rangeStartLabel }}</label>
        <div class="tt-chart-range-controls__field w-full min-w-0">
          <input
            #rangeStartInput
            [id]="idPrefix + '-start'"
            [type]="rangeInputType"
            [ngModel]="rangeStart"
            (ngModelChange)="onRangeStartInput($event)"
            (blur)="onBlur()"
            class="input tt-filter-control w-full tt-chart-range-controls__input">
          <button
            type="button"
            class="tt-chart-range-controls__trigger"
            aria-label="Otevřít kalendář od"
            title="Otevřít kalendář"
            (click)="openPicker(rangeStartInput, $event)">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10m-11 9h12a2 2 0 002-2V7a2 2 0 00-2-2H6a2 2 0 00-2 2v11a2 2 0 002 2z"></path>
            </svg>
          </button>
        </div>
      </div>

      <div>
        <label class="tt-chart-range-controls__label block mb-1" [for]="idPrefix + '-end'">{{ rangeEndLabel }}</label>
        <div class="tt-chart-range-controls__field w-full min-w-0">
          <input
            #rangeEndInput
            [id]="idPrefix + '-end'"
            [type]="rangeInputType"
            [ngModel]="rangeEnd"
            (ngModelChange)="onRangeEndInput($event)"
            (blur)="onBlur()"
            class="input tt-filter-control w-full tt-chart-range-controls__input">
          <button
            type="button"
            class="tt-chart-range-controls__trigger"
            aria-label="Otevřít kalendář do"
            title="Otevřít kalendář"
            (click)="openPicker(rangeEndInput, $event)">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10m-11 9h12a2 2 0 002-2V7a2 2 0 00-2-2H6a2 2 0 00-2 2v11a2 2 0 002 2z"></path>
            </svg>
          </button>
        </div>
      </div>
    </div>

    <p *ngIf="rangeErrorMessage" class="mt-0 text-sm text-red-600 dark:text-red-400">{{ rangeErrorMessage }}</p>
  </div>
</div>
